/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.16.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { ELinkTarget } from '../../../../../../components/common/ExternalLink/ExternalLink';
import { ONBOARDING_DATA_ATTR } from '../../../../../../modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '../../../../../../modules/onboarding/types/onboardingTypes';
import { colors, fonts } from '../../../../../../theme';
import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import { IWidgetStyled } from '../../widgetTypes';

export interface IWidgetPersonalAccountBalanceText {
    isBalanceDanger: boolean | undefined;
    isCredit: boolean | undefined;
}

export const WidgetPersonalAccountContainerStyled = styled(WidgetBlockStyled).attrs((props: IWidgetStyled) => ({
    className: `widget__widget-account ${props.isLoading ? 'widget__widget-account_loading' : ''}`,
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.widgetPersonalAccount,
}))<IWidgetStyled>`
    display: flex;
    flex-direction: column;
    min-height: 365px;

    &.widget__widget-account_loading {
        display: flex;
        flex-direction: column;
        height: 360px;
        box-sizing: border-box;

        .widget__widget-skeleton_button {
            display: flex;
            flex-basis: 100%;
            align-items: flex-end;
        }

        .widget__widget-skeleton_paragraph_normal {
            margin: 4px 0 32px;
        }
    }

    .widget-account__btn-promised-payment,
    .widget-account__btn-promised-payment button,
    .widget-account__btn-bill,
    .widget-account__btn-bill button {
        width: 100%;
    }

    .widget-personal-account__credit-notification .widget-personal-account__notification:last-child {
        margin-bottom: 0;
    }

    .widget-personal-account__cashback-link {
        margin-left: 16px;
    }
`;

export const WidgetPersonalAccountLinkStyled = styled.a.attrs({
    target: ELinkTarget.PARENT,
})``;

export const WidgetPersonalAccountBalanceDateStyled = styled.span.attrs({
    className: 'widget-personal-account__balance-date',
})`
    ${fonts.textSmall};
    color: ${colors.pageDashboardWidgetSecondaryText};
`;

export const WidgetPersonalAccountBalanceTitleStyled = styled.span.attrs({
    className: 'widget-personal-account__balance-title',
})`
    color: ${colors.pageDashboardWidgetSecondaryText};
`;

export const WidgetPersonalAccountBalanceTextStyled = styled.div.attrs({
    className: 'widget-personal-account__balance-text',
})<IWidgetPersonalAccountBalanceText>`
    ${fonts.textMain};
    font-size: 20px;
    font-weight: ${props => props.isCredit ? '500' : '400'};
    color: ${props => props.isBalanceDanger ? colors.pageDashboardWidgetWarningText : colors.pageDashboardWidgetText};
`;

export const WidgetPersonalAccountCashbackTitleStyled = styled.span.attrs({
    className: 'widget-personal-account__cashback-title',
})`
    color: ${colors.pageDashboardWidgetSecondaryText};
`;

export const WidgetPersonalAccountCashbackRowBodyStyled = styled.div`
    ${fonts.textMain};
    font-size: 20px;
    font-weight: 400;
`;

export const WidgetPersonalAccountTypeStyled = styled.span.attrs({
    className: 'widget-personal-account__type',
})`
    color: ${colors.pageDashboardWidgetSecondaryText};
`;
